import { Slider } from '@polyai/ui/components/atoms/Slider';

import { useSurveyEnabled } from 'hooks/useSurveyEnabled';
import ResetButton from '../ResetButton';
import * as Styled from './ProgressSlider.styled';

interface ProgressSliderProps {
  step: number;
  showResetButton?: boolean;
  resetButtonRedirectUrl?: string;
  maxSteps?: number;
  disabled?: boolean;
}

const ProgressSlider = ({
  step,
  showResetButton = true,
  resetButtonRedirectUrl,
  maxSteps,
  disabled,
}: ProgressSliderProps) => {
  const isSurveyEnabled = useSurveyEnabled();

  const finalMaxSteps = maxSteps ?? (isSurveyEnabled ? 5 : 4);

  const adjustedStep = isSurveyEnabled || step <= 2 ? step : step - 1;

  const segments = Array.from({ length: finalMaxSteps }, (_, i) => ({
    label: String(i + 1),
    value: i,
  }));

  return (
    <Styled.TopBar>
      {showResetButton && (
        <ResetButton disabled={disabled} redirectUrl={resetButtonRedirectUrl} />
      )}
      <Styled.SliderWrapper $filledSegments={adjustedStep}>
        <Slider
          segments={segments}
          value={adjustedStep}
          disabled
          hideKnobTooltip
        />
      </Styled.SliderWrapper>
    </Styled.TopBar>
  );
};

export default ProgressSlider;
